import React, { useState, useEffect, useMemo } from "react";
import { withTranslation } from "react-i18next";
import constants from "../../../../constants";
import moment from "moment";
import CustomDropdown from "components/Dropdown";
import styles from "../Dashboard.module.scss";
import Text from "components/Text";
import OpenInIcon from "../../../../assets/images/open_in_new_mobile.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { setStorage } from "utils";
import Separator from "assets/images/Separator.svg";

const SchedularDashboardHeaderMobile = ({
  t,
  handleSchedule,
  isMySchedule,
  staffAvailabilityViewSelectedFromDashBoard,
  handleAvailabilityViewSelectedFromDashBoard,
  currentDateFromDashBoard,
  setCurrentDateFromDashBoard,
  setIsModalOpen,
  isSchedulerFeatureEnabled,
}) => {
  const history = useHistory();

  const staffAvailabilityView = [
    { id: "1", name: "Daily" },
    { id: "2", name: "Weekly" },
    { id: "3", name: "Monthly" },
  ];

  // Retrieve date from sessionStorage or set default to current date
  const initialDate = sessionStorage.getItem(constants.staffAvalibilityDate);
  const currentDate = useMemo(
    () => (initialDate ? new Date(initialDate) : new Date()),
    [initialDate]
  );

  // Update sessionStorage whenever the date changes
  useEffect(() => {
    sessionStorage.setItem(
      constants.staffAvalibilityDate,
      moment(currentDate).toISOString()
    );
  }, [currentDate]);

  // Handle navigation between dates
  const dateChange = (type) => {
    let newDate = new Date(currentDate);

    switch (staffAvailabilityViewSelectedFromDashBoard) {
      case "1": // Daily View
        newDate =
          type === constants.arrow.PREVIOUS
            ? moment(currentDateFromDashBoard).subtract(1, "day").toDate()
            : moment(currentDateFromDashBoard).add(1, "day").toDate();
        break;
      case "2": // Weekly View
        newDate =
          type === constants.arrow.PREVIOUS
            ? moment(currentDateFromDashBoard)
                .subtract(1, "week")
                .startOf("week")
                .toDate()
            : moment(currentDateFromDashBoard)
                .add(1, "week")
                .startOf("week")
                .toDate();
        break;
      case "3": // Monthly View
        newDate =
          type === constants.arrow.PREVIOUS
            ? moment(currentDateFromDashBoard).subtract(1, "month").toDate()
            : moment(currentDateFromDashBoard).add(1, "month").toDate();
        break;
      default:
        break;
    }

    setCurrentDateFromDashBoard(newDate);
  };

  const getDisplayDate = () => {
    switch (staffAvailabilityViewSelectedFromDashBoard) {
      case "1": // Daily
        return moment(currentDateFromDashBoard).format("ddd, MMM DD, YYYY");
      case "2": // Weekly
        const startOfWeek = moment(currentDateFromDashBoard)
          .startOf("isoweek")
          .format("ddd, MMM DD");
        const endOfWeek = moment(currentDateFromDashBoard)
          .endOf("isoweek")
          .format("ddd, MMM DD");
        return `${startOfWeek} - ${endOfWeek}`;
      case "3": // Monthly
        return moment(currentDateFromDashBoard).format("MMM YYYY");
      default:
        return "";
    }
  };

  const handleRedirect = (e) => {
    if (e.target.closest(".interactive-element")) {
      return;
    }
    history.push(constants.routes.scheduler.calendar);
    setStorage("isChatFromDashBoard", true);
  };

  return (
    <div className={styles.mobile_header_wrapper}>
      {/* 1st row */}
      <div className={styles.mobile_header_first_row}>
        <Text size="16px" weight="600" color="#2D3245">
          Scheduler
        </Text>
        {isSchedulerFeatureEnabled && (
          <div className="pl-2 d-flex gap-sm">
            <button
              className={styles["add-chat-button"]}
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              <img
                src={require("assets/images/plus-icon-outline.svg").default}
                alt="icon"
              />
            </button>
            <img src={Separator} alt="separator" />
            <div  onClick={handleRedirect}>
              <img src={OpenInIcon} alt="open-icon" />
            </div>
          </div>
        )}
      </div>
      {/* 2nd row */}
      <div className={styles.mobile_header_first_row}>
        <div className="ch-checkbox c-field all-event-checkbox m-0">
          <label>
            <input
              type="checkbox"
              checked={isMySchedule || false}
              onChange={handleSchedule}
            />
            <span>{t("My Schedule")}</span>
          </label>
        </div>
        <CustomDropdown
          options={staffAvailabilityView}
          selectedOption={staffAvailabilityViewSelectedFromDashBoard}
          selectOption={(id) => {
            handleAvailabilityViewSelectedFromDashBoard(id);
          }}
        />
      </div>
      {/* 3rd row */}

      <div
        className={
          styles.mobile_header_first_row + " " + "monthly-calendar-arrows m-0"
        }
      >
        <div
          className="arrow-img-dashboard"
          onClick={() => dateChange(constants.arrow.PREVIOUS)}
        >
          <img
            src={require("assets/images/monthly-arrow-left.svg").default}
            alt="Previous"
          />
        </div>

        <div className={styles.monthly_calendar_text}>{getDisplayDate()}</div>

        <div
          className="arrow-img-dashboard"
          onClick={() => dateChange(constants.arrow.NEXT)}
        >
          <img
            src={require("assets/images/monthly-arrow-right.svg").default}
            alt="Next"
          />
        </div>
      </div>
    </div>
  );
};
export default withTranslation()(SchedularDashboardHeaderMobile);
